var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormButton',{attrs:{"variant":_vm.ButtonVariants.SECONDARY,"icon":_vm.IconEnums.REMINDER,"loading":_vm.loading},nativeOn:{"click":function($event){return _vm.sendReminder(_vm.item)}}},[_vm._v(" "+_vm._s(_vm.$t("training.deadlines.send_reminder"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }